module.exports = (__parcel__import__("5LydO")).then(() => parcelRequire('emu4l'));